<template>
	<div id="app">
		<div class="app" v-if="$store.state.isMobile">
			<!-- <common-header></common-header> -->
			<div class="router-view"><router-view /></div>
			<div class="back f-a-j colFFF pointer" v-if="isShowScrollBtn" @click="scrollTop"><i class="el-icon-arrow-up"></i></div>
			<div class="app-bottom">
				<div>©2022 泉润. All rights reserved</div>
				
				<!-- <div class="f18 list">
					<li>
						<a href="http://www.植美村.com" target="_blank">植美村官网</a>
					</li>
				</div> -->
			</div>
			<div class="tab-bar-pl" style="height: 60px;"></div>
			<tab-bar></tab-bar>
		</div>
		<div class="pc" v-else>
			<common-header></common-header>
			<div class="router-view"><router-view /></div>
			<div class="back f-a-j colFFF pointer" v-if="isShowScrollBtn" @click="scrollTop"><i class="el-icon-arrow-up"></i></div>
			<div class="pc-bottom">
				<div>©2024 泉润. All rights reserved</div>
				<!-- <div class="f18 list">
					<li>
						<a href="http://www.植美村.com" target="_blank">植美村官网</a>
					</li>
				</div> -->
			</div>
		</div>
		
	</div>
</template>
<script>
import header from './components/Header.vue';
import tabBar from "./components/app/tab-bar.vue"
import { Loading } from 'vant';
export default {
	components: {
		CommonHeader: header,
		tabBar
	},
	data() {
		return {
			isShowScrollBtn: false
		};
	},
	created() {
		window.onscroll = () => {
			if (window.scrollY > 200) {
				this.isShowScrollBtn = true;
			} else {
				this.isShowScrollBtn = false;
			}
		};
	},
	mounted() {
		
	},
	methods: {
		scrollTop() {
			window.scroll(0, 0);
		}
	}
};
</script>
<style lang="less" >
@import url('common/common.css');
.pc {
	position: relative;
	width: 80vw;
	min-width: 1200px;
	overflow-x: auto;
	margin: 0 auto;
	padding-bottom: 86px;
	.router-view {
		margin-top: 76px;
	}
}
.app {
	margin: 0 auto;
	padding-bottom: 30px;
	.router-view {
		// margin-top: 76px;
		
	}
	.back {
		position: fixed;
		bottom: 80px;
		right: 10px;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: skyblue;
		font-size: 20px;
	}
}
.pc-bottom {
	position: fixed;
	bottom: 0px;
	width: 100%;
	left:0;
	text-align: center;
	background-color: rgba(21, 80, 131,0.8);
	color: rgb(255, 255, 255);
	z-index: 9999;
	font-size: 24px;
	font-weight: bold;
	line-height: 30px;
	.list{
		li{
			height: 40px;
			line-height: 40px;
		}
	}
}
.app-bottom{
	width: 100%;
	text-align: center;
	// background-color: rgb(21, 80, 131);
	font-size: 24px;
	font-weight: bold;
	line-height: 30px;
	margin-top: 40px;
	.list{
		li{
			height: 40px;
			line-height: 40px;
		}
	}
}
.back {
	position: fixed;
	bottom: 90px;
	right: 40px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: skyblue;
	font-size: 20px;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
html::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道 内阴影+圆角*/
html::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
html::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
html{
	overflow-y: overlay;
}
</style>
